






























import Vue from 'vue'
import { Popover } from 'element-ui'
import './CreateEventButton.scss'

export default Vue.extend({
  name: 'CreateEventButton',
  data: () => ({
    isVisible: false
  }),
  mounted () {
    setTimeout(() => this.isVisible = true, 100)
  },
  computed: {
    showSelfServeWelcomeMessage: {
      get (): boolean {
        return this.$store.direct.getters.user.showSelfServeWelcomeMessage && this.isVisible
      },
      set (_value: boolean) {}
    }
  },
  methods: {
    createEvent (event: Event) {
      event.stopPropagation()
      this.closePopup()
      this.$emit('clicked')
    },
    closePopup () {
      this.$store.direct.dispatch.user.closeSelfServeWelcomePopup()
    },
    openSupport (event: Event) {
      event.stopPropagation()
      this.$router.push({ name: 'selfServeSupport' })
    }
  },
  components: {
    'el-popover': Popover
  }
})
